import React from "react";
import Box from "../../components/Box";
import styled from "styled-components";
import Textfield from "../Merchant/Textfield";
import Selectfield from "../Merchant/Selectfield";
import { Colors } from "../../config/Constants";
import UploadAccountImages from "./UploadAccountImages";
import Button from "../Button";
import BenefitsPDF from "./BenefitsPDF";

interface Props {
  error: any;
  data: any;
  onChange: (e: any, idx?: any) => void;
  accountTypes: any;
  onAddMoreBenefits: any;
  uploadedImage: any;
  onRemove: any;
  onPDFRemove:any
  onCancel: any;
  onSubmit: any;
}

const PrivilegeAccountForm = ({
  onChange,
  data,
  error,
  accountTypes,
  onAddMoreBenefits,
  uploadedImage,
  onRemove,
  onCancel,
  onSubmit,
  onPDFRemove
}: Props) => {
  return (
    <PrivilegeAccountFormWrapper>
      <Box>
        <FormWrapper>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="name"
                label="Account Name"
                placeholder="Enter Privilege Name"
                onChange={onChange}
                value={data.name}
                required
                helperText={error["name"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Selectfield
                data={[
                  { label: "Select Privilege Type", value: "" },
                  ...accountTypes,
                ]}
                name="type"
                label="Account Type"
                required
                value={data?.type}
                onChange={(e) => onChange(e)}
                helperText={error["type"]}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="percentage"
                label="Discount %"
                placeholder="Enter Discount %"
                onChange={onChange}
                value={data.percentage}
                required
                helperText={error["percentage"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Textfield
                name="qrLineColor"
                label="QR Code Colour code"
                placeholder="Enter QR Code Colour code*"
                onChange={onChange}
                value={data.qrLineColor}
                required
                helperText={error["qrLineColor"]}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Label>Account Benefits{<span>*</span>}</Label>
              <FieldGroupWrapper>
                {data.benefits.map((benefit: any, index: any) => (
                  <Textfield
                    name="benefits"
                    label=""
                    placeholder={`Enter Benefit ${index + 1}`}
                    onChange={(e) => onChange(e, index)}
                    value={benefit}
                    required
                    helperText={error["benefits"]}
                  />
                ))}
              </FieldGroupWrapper>
              <LinkButtonWrapper>
                <StyledLinkButton onClick={onAddMoreBenefits}>
                  Add more Benefits
                </StyledLinkButton>
              </LinkButtonWrapper>
            </FieldWrapper>
            <FieldWrapper>
              <Textfield
                name="nameTextColor"
                label="Menu User Name Color Code"
                placeholder="Enter Menu User Name Color Code*"
                onChange={onChange}
                value={data.nameTextColor}
                required
                helperText={error["nameTextColor"]}
              />
              <BenefitsPDF
                onChange={onChange}
                name="benefitsFile"
                urls={data.benefitsFile}
                onRemove={onPDFRemove}
              />
            </FieldWrapper>
          </FormRow>
        </FormWrapper>
      </Box>
      <StyledPageHeader>Badge Images</StyledPageHeader>
      <Box>
        <FormWrapper>
          <FormRow>
            <FieldWrapper>
              <UploadAccountImages
                name="badgeHomeImg"
                label="Home Screen Badge"
                onChange={onChange}
                onRemove={onRemove}
                required
                uploadedImage={uploadedImage}
                helperText={error["badgeHomeImg"]}
                maxImages={1}
                subLabel="Only JPEG or PNG files are allowed. Max size: 2MB. Recommended dimensions: 750x120."
                urls={data.badgeHomeImg}
                acceptFormats=".jpeg, .jpg, .png"
              />
            </FieldWrapper>
            <FieldWrapper>
              <UploadAccountImages
                name="badgeProfileImg"
                label="Profile Screen Badge"
                onChange={onChange}
                onRemove={onRemove}
                required
                uploadedImage={uploadedImage}
                helperText={error["badgeProfileImg"]}
                maxImages={1}
                subLabel="Only JPEG or PNG files are allowed. Max size: 2MB. Recommended dimensions: 750x150."
                urls={data.badgeProfileImg}
                acceptFormats=".jpeg, .jpg, .png"
              />
            </FieldWrapper>
          </FormRow>
        </FormWrapper>
      </Box>
      <StyledPageHeader>Background</StyledPageHeader>
      <Box>
        <FormWrapper>
          <FormRow>
            <FieldWrapper>
              <UploadAccountImages
                name="bgMenuImg"
                label="Menu Image"
                onChange={onChange}
                onRemove={onRemove}
                required
                uploadedImage={uploadedImage}
                helperText={error["bgMenuImg"]}
                maxImages={1}
                subLabel="Only JPEG or PNG files are allowed. Max size: 2MB. Recommended dimensions: 654x808"
                urls={data.bgMenuImg}
                acceptFormats=".jpeg, .jpg, .png"
              />
            </FieldWrapper>
          </FormRow>
        </FormWrapper>
      </Box>
      <Gap height="6px" />
      <Box>
        <FormWrapper>
          <FormRow>
            <FieldWrapper>
              <UploadAccountImages
                name="bgHomeImg"
                label="Home Screen"
                onChange={onChange}
                onRemove={onRemove}
                required
                uploadedImage={uploadedImage}
                helperText={error["bgHomeImg"]}
                maxImages={1}
                subLabel="Only JPEG or PNG files are allowed. Max size: 2MB. Recommended dimensions: 375x812"
                urls={data.bgHomeImg}
                acceptFormats=".jpeg, .jpg, .png"
              />
            </FieldWrapper>
          </FormRow>
        </FormWrapper>
      </Box>
      <ActionRow>
        <ButtonWrapper>
          <Button
            variant="outlined"
            label="Cancel"
            onClick={onCancel}
            width="9.7rem"
          />
          <Button
            color={Colors.red}
            variant="filled"
            label="Save"
            onClick={onSubmit}
            width="9.7rem"
          />
        </ButtonWrapper>
      </ActionRow>
    </PrivilegeAccountFormWrapper>
  );
};

interface GapProps {
  height: string;
  height2?: string;
}

const ButtonWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
    margin-top: 2rem;
  }
  @media only screen and (max-width: 350px) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;

export const Gap = styled.div<GapProps>`
  height: ${(GapProps) => GapProps.height};
  @media only screen and (max-width: 768px) {
    height: ${(GapProps) =>
      GapProps.height2 ? GapProps.height2 : GapProps.height};
  }
`;

const ActionRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
`;

const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  margin: 1.5rem 0;
  @media only screen and (max-width: 768px) {
    margin: 0 0 0 2rem;
  }
`;

const PrivilegeAccountFormWrapper = styled.div`
  margin-top: 1rem;
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
  }
`;

const FormRow = styled.div`
  display: flex;
  gap: 0.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const Label = styled.label`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 350;
  font-size: 13px;
  line-height: 16px;
  color: ${Colors.electricBlue};
  margin-bottom: 0.5rem;
  > span {
    color: ${Colors.red};
    margin-left: 2px;
  }
`;

const FieldWrapper = styled.div`
  flex: 1;
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;

const FieldGroupWrapper = styled.div`
  flex: 1;
  gap: 0.5rem;
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;

const LinkButtonWrapper = styled.div`
  flex: 1;
  text-align: right;
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;

const StyledLinkButton = styled.button`
  background: transparent;
  border: none;
  color: ${Colors.red};
  font-family: Poppins-Medium;
  text-decoration: underline;
  font-weight: 600;
  font-size: 0.9rem;
  margin: 0.5rem 0;
`;

export default PrivilegeAccountForm;
